import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  provinces() {
    return http.get(endpoints.get('publicProvinces'))
  },
  schoolsPerProvince(provinceId: string) {
    return http.get(endpoints.get('publicSchoolsPerProvince', { provinceId }))
  },
  consent(consentFormName: string) {
    return http.get(endpoints.get('consent', { consentFormName }))
  },
  document(type: string, isPublic = false, editionName?: string) {
    const endpointLabel = isPublic ? 'publicResourceDocument' : 'resourceDocument'
    return http.get(endpoints.get(endpointLabel, { documentType: type, editionName }))
  },
  permissionedProvinces() {
    return http.get(endpoints.get('provinces'))
  },
  permissionedSchoolsPerProvince(provinceId: string) {
    return http.get(endpoints.get('schoolsPerProvince', { provinceId }))
  },
  traditionalPaymentStatus() {
    return http.get(endpoints.get('traditionalPaymentStatus'))
  },
  excludeChildReasons() {
    return http.get(endpoints.get('excludeChildReasons'))
  },
  successCard(editionName: string) {
    return http.get(endpoints.get('resourceSuccessCard', { editionName }))
  },
  donorContact(editionName: string) {
    return http.get(endpoints.get('resourceDonorContact', { editionName }))
  },
  paymentListFilterData() {
    return http.get(endpoints.get('paymentListFilterData'))
  },
  childrenListFilterData() {
    return http.get(endpoints.get('childrenListFilterData'))
  },
  schoolsWithProvinceFilterData() {
    return http.get(endpoints.get('schoolsWithProvinceFilterData'))
  },
  canSuccessCardAcceptDisplayInGiftGiverModule(payload: {
    childEditionId: string
    successCardId: string
  }) {
    return http.get(endpoints.get('canSuccessCardAcceptDisplayInGiftGiverModule', payload))
  },
  canSuccessCardChangeDisplayInGiftGiverModule(payload: {
    childEditionId: string
    successCardId: string
  }) {
    return http.get(endpoints.get('canSuccessCardChangeDisplayInGiftGiverModule', payload))
  }
}
